import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { TranslateModule } from '@ngx-translate/core';

export interface CopilotSnackbarData {
  message: string;
}

@Component({
  selector: 'app-copilot-snackbar',
  standalone: true,
  imports: [MatButtonModule, MatIconModule, TranslateModule],
  template: `
    <div class="flex h-12 w-full items-center">
      <span class="body-medium flex flex-1 items-center pl-4 tracking-[0.25px] text-[var(--color-inverse-on-surface)]">
        {{ data.message }}
      </span>
      <button
        mat-icon-button
        type="button"
        (click)="dismiss()"
        [attr.aria-label]="'Close' | translate"
        class="copilot-snackbar-dismiss shrink-0">
        <mat-icon class="copilot-snackbar-dismiss-icon">close</mat-icon>
      </button>
    </div>
  `,
})
export class CopilotSnackbarComponent {
  readonly data = inject<CopilotSnackbarData>(MAT_SNACK_BAR_DATA);
  private readonly snackBarRef = inject(MatSnackBarRef);

  dismiss(): void {
    this.snackBarRef.dismiss();
  }
}
